import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allEntCarrerasAction } from '../../../entidad/ent_carreras/EntCarrerasAction';
import { allEntNivelesAcademicosAction } from '../../../entidad/ent_niveles_academicos/EntNivelesAcademicosAction';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allSeccionesAction,
  deleteSeccionesAction,
  setActivoSeccionesAction,
} from '../SeccionesAction';
import { PARAMS_SECCIONES } from '../SeccionesReducer';
import ExpandedSeccionesComponent from './ExpandedSecciones';

const ListadoSecciones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const seccionesStore = Redux.useSelector((state) => state.secciones);
  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      if (
        entNivelesAcademicosStore.all &&
        entNivelesAcademicosStore.all.length === 0
      ) {
        await allEntNivelesAcademicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
      if (entCarrerasStore.all && entCarrerasStore.all.length === 0) {
        await allEntCarrerasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      const payload = {
        idEntidad: entidadesStore.activo.id,
        ...seccionesStore.params,
      };
      dispatch({ type: PARAMS_SECCIONES, payload });
      if (seccionesStore.all && seccionesStore.all.length === 0) {
        await allSeccionesAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    seccionesStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        nivelAcademico: el.nivelAcademico?.nivelAcademico?.nombre ?? '--',
        carrera: el.carrera?.carrera?.nombre ?? '--',
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [seccionesStore.all]);

  function getDataStore(id) {
    return seccionesStore.all.find((el) => el.id === id);
  }

  const _handleEditClick = async (id) => {
    const data = getDataStore(id);
    await setActivoSeccionesAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteSeccionesAction(
      { dispatch, notify },
      seccionesStore.activo.id,
      seccionesStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nivelAcademico.name,
      label: CONST.nivelAcademico.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.seccion.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.turno.name,
      label: CONST.turno.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.capacidad.name,
      label: CONST.capacidad.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.code.name,
      label: CONST.code.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.grupos.name,
      label: CONST.grupos.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.carrera.name,
      label: CONST.carrera.label,
      options: {
        filter: true,
        sort: true,
      },
      customBodyRender: (value, tableMeta, updateValue) =>
        value ? <Typography>{value.seccion.nombre}</Typography> : null,
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = getDataStore(tableMeta.rowData[0]);
                  await setActivoSeccionesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  const data = getDataStore(tableMeta.rowData[0]);
                  window.open(data.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = getDataStore(rowData[0]);
      return <ExpandedSeccionesComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={seccionesStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {seccionesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            Sección {seccionesStore.activo.nombre} de{' '}
            {seccionesStore.activo.nivelAcademico.nivelAcademico.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoSecciones;
